/**
 * Originally this was intended to record ONLY sessions that were relevant by putting
 * configuration at the gate level. record_playboks, could indicate Fullstory only run
 * on a subset of pages related to playbooks
 *
 * Due to shortcomings in the fullstory API (and their biz model based on recorded sessions),
 * so they discourage reducing # of sessions recorded, I've abandoned that idea in favor of having
 * a single gate `record_sessions` that injects fullstory selectively. We end up with more sessions
 * recorded, but we avoid the noisey firehose of sessions that we'd have if it was enabled for all.
 */
export const FullStorySettings = {
  debug: true,
  host: 'fullstory.com',
  orgKey: '13D52',
}

const shouldRecordSession = gates => {
  const recordingTargets = gates.filter((value, key) => key.includes('record_sessions') && value)
  return recordingTargets.size > 0
}

export default shouldRecordSession



// WEBPACK FOOTER //
// ./src/scripts/utils/SessionRecording.js